import { Box, Divider, Typography } from "@mui/material"
import React from "react";
import {ReactComponent as CancelFilled} from "./assets/CancelFilled.svg";
import {ReactComponent as CheckCircleFilled} from "./assets/CheckCircleFilled.svg";

const ValueProp4: React.FC = () => {

  const bodyItems = [
    {
      "left": "Burnout answering DMs, emails, chats, phone calls, zoom calls...",
      "right": "AI persona answers instantly, 24/7, in your voice",
    },
    {
      "left": "Only earn when you're actively working or creating content",
      "right": "Generate passive income while you sleep, travel, or focus on new projects or more important tasks",
    },
    {
      "left": "Miss potential fans due to time zones and response delays",
      "right": "Engage with global audience instantly, never miss an opportunity",
    },
    {
      "left": "Constantly tied to your phone, answering DMs and emails",
      "right": "Reclaim your personal time while your AI handles routine interactions",
    },
  ]

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: "lg",
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        px: {xs: 1, md: 5},
        py: 4
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Typography variant="h5">
          Built with experts in mind
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Build trust and curiosity with personalized experiences
        </Typography>
      </Box>

      <Box
        sx={{
          width: '100%',
          flexDirection: 'column',
          gap: 2,
          borderRadius: 1.5,
          backgroundColor: theme => theme.palette.background["container-1"],
          p: 1.5,
        }}
      >
        <Box id="vp4-title"
          sx={{
            display: 'flex',
            pb: 2,
          }}
        >
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            <Typography variant='h6' color='text.secondary'>
              Without Soopra
            </Typography>
          </Box>
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            <Typography variant='h6' color='text.primary'>
              With Soopra
            </Typography>
          </Box>
        </Box>

        <Box id="vp4-body"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          {
            bodyItems.map((item, ind) => (
              <BodyItem
                key={`vp4-body-${ind}`}
                left={item.left}
                right={item.right}
                isEven={ind % 2 === 0}
              />
            ))
          }
        </Box>
      </Box>
    </Box>
  )
}

export default ValueProp4;

interface BodyItemProps {
  left: string;
  right: string;
  isEven: boolean;
}

const BodyItem: React.FC<BodyItemProps> = ({left, right, isEven}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        backgroundColor: isEven ? 'none' : theme => theme.palette.background["container-3"],
        py: 0.5,
      }}
    >
      <Box id="vp4-body-left"
        sx={{
          display: 'flex',
          px: 1.5,
          gap: 1,
          flex: 1,
        }}
      >
        <CancelFilled />
        <Typography variant='body1' color='text.secondary'>
          {left}
        </Typography>
      </Box>

      <Divider orientation="vertical" variant="middle" flexItem />

      <Box id="vp4-body-right"
        sx={{
          display: 'flex',
          px: 1.5,
          gap: 1,
          flex: 1,
        }}
      >
        <CheckCircleFilled />
        <Typography variant='body1' color='text.primary'>
          {right}
        </Typography>
      </Box>
    </Box>
  )
}
